/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\Paragraphe.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 5:05:10 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const ParagrapheStyled = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
&:hover{
    text-decoration: underline ${(props: any) => getThemeColor(props.bgColor)};
}
`

export default ParagrapheStyled;
